import Amplify from 'aws-amplify'
import { App } from './app'
import { withConfig } from './new_lib'
import { withAuthenticator } from './new_components/auth'
import { AWSAmplify } from './awsConfig'
import config from './app/configuration/Template'
Amplify.configure(AWSAmplify)

export default withConfig(config)((withAuthenticator(App)))



// WEBPACK FOOTER //
// ./src/Root.js